import { useEffect } from "react";
import { toast } from "sonner";
import { activateWaitingWorker } from "@/swRegistration";
import { RefreshCcw } from "lucide-react";

/**
 * Listens for SW update events and shows a persistent toast with a "Recarregar" action.
 * Drop this component once (e.g., inside App or the main Layout).
 */
export default function ServiceWorkerUpdateToast() {
  useEffect(() => {
    let shown = false;
    const handleUpdate = () => {
      if (shown) return;
      shown = true;
      toast(
        (t) => (
          <div className="flex items-center gap-3">
            <RefreshCcw className="w-5 h-5 text-[#7B2D3F]" />
            <div className="flex-1">
              <div className="font-semibold text-gray-900">Nova versió d'Ho-Sys disponible</div>
              <div className="text-xs text-gray-600">Recarrega per aplicar les últimes millores.</div>
            </div>
          </div>
        ),
        {
          duration: Infinity,
          id: "sw-update",
          action: {
            label: "Recarregar",
            onClick: () => {
              activateWaitingWorker();
            },
          },
          dismissible: true,
        }
      );
    };

    window.addEventListener("hosys:sw-update-available", handleUpdate);
    return () => window.removeEventListener("hosys:sw-update-available", handleUpdate);
  }, []);

  return null;
}
